import { ReactComponent as Delete } from "../../../../assets/icons/cancel.svg";

const DeleteIcon = (props) => {
  return <Delete style={{ cursor: "pointer" }} fill={"#6fc0ff"} />;
};

export default DeleteIcon;
